<template>
  <div class="row-card">
    <Avatar :label="label" :icon="icon" size="large" />
    <div class="texts">
      <span class="subtitle-bold">{{ title }}</span>
      <span class="text"> {{ content }}</span>
    </div>
    <Button
      v-if="showButton"
      :icon="btnIcon"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

defineEmits(['buttonClick']);

const props = defineProps({
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    showButton: {
      type: Boolean,
      default: false
    },
    buttonIcon: {
      type: String,
      required: false,
      default: 'pi-trash'
    }
  })

const btnIcon = ref('pi ' + props.buttonIcon)
</script>

<style scoped lang="scss">
@use '../../../../assets/css/vars'  as *;

.row-card {
  display: flex;
  width: 100%;
  padding: 0.5rem 0.25rem;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  &:hover {
    background-color: $gray-bg;
  }

  .texts {
    display: flex;
    height: 3rem;
    flex-grow: 1;
    flex-direction: column;
    margin-right: 1rem;
    align-items: flex-start;
    justify-content: space-evenly;
  }

  .p-button {
    background: transparent;
    border: none;
    color: black;

    &:hover {
      color: grey;
    }
  }
}
</style>
